<template>
    <div class="home grid gg1 gc1 gc2-ns mw8 center">
        <p v-if="error.length > 0" class="red f6 ph3">{{ error }}</p>
        <div v-if="isLoading" class="aspect-ratio--object flex items-center justify-center">
            <div class="spinner"></div>
        </div>

        <Hero :cityName="locationName"
          :weatherMood="getWeatherMood"
          :temperature="tempFormatted"
          class="gc-start-1-ns gc-end-3-ns"/>

        <DailyOverview :hours="forecast.hourly.data" class="gc-start-1 gc-end-2"/>
        <Forecast :forecast="forecast.daily.data" />
    </div>
</template>

<script>
// @ is an alias to /src
import Hero from '@/components/Hero.vue';
import DailyOverview from '@/components/DailyOverview.vue';
import Forecast from '@/components/Forecast.vue';

export default {
    name: 'home',
    components: {
        Hero,
        DailyOverview,
        Forecast,
    },
    created() {
        this.fetchWeatherData();
    },
    data() {
        return {
            forecast: {
                daily: {
                    data: [],
                },
                hourly: {
                    data: [],
                },
            },
            lat: '48.2949799',
            lng: '14.1873218',
            locationName: '',
            isLoading: true,
            error: '',
        };
    },
    computed: {
        getWeatherMood() {
            if (this.forecast.currently) {
                return this.forecast.currently.summary;
            }
            return '';
        },
        tempFormatted() {
            if (!this.forecast.currently) {
                return '';
            }

            let appendix = 'F';
            switch (this.$root.units) {
            case 'metric':
                appendix = '°';
                break;
            case 'imperial':
                appendix = 'F';
                break;
            default:
                appendix = 'F';
                break;
            }

            return `${Math.round(this.forecast.currently.temperature)}${appendix}`;
        },
    },
    methods: {
        fetchWeatherData() {
            this.$root.weatherService.getForecast(this.lat, this.lng)
                .then((res) => {
                    this.locationName = 'Linz';
                    this.forecast = res.data;
                    this.isLoading = false;
                })
                .catch((err) => {
                    console.error(err);
                    this.error = err.message;
                    this.isLoading = false;
                });
        },
    },
};
</script>
